<div class="mainDetails" *ngIf="singlePost !== undefined">
  <button class="outsideButton" (click)="back()">Back</button>

  <section class="detailsTop">
    <div class="map-cont">
      <app-map [lat]="lat" [long]="long" *ngIf="lat !== undefined"></app-map>
    </div>
    <div class="img-cont">
      <button *ngIf="singlePost['gallery'].length > 1" (click)="swipeLeft()">←</button>
      <img [src]="singlePost['gallery'][imgIndex]" alt="">
      <button *ngIf="singlePost['gallery'].length > 1" (click)="swipeRight()">→</button>
    </div>
  </section>
  <section class="detailsBottom">
    <div class="data-cont">
      <div>
        <h3>{{singlePost['item']}} |</h3>
        <h3 *ngIf="singlePost['price'] !== '0.00'"> {{singlePost['price'] | currency}}</h3>
        <h3 *ngIf="singlePost['price'] === '0.00'">FREE</h3>
      </div>
      <h3 class='outsideH3'>Address</h3>

      <h2>{{singlePost['address']}}, {{singlePost['city']}}, {{singlePost['state']}} {{singlePost['zipcode']}}</h2>
      <h3 class='outsideH3'>Details</h3>
      <div class="innerDetails">
        <h4 class="short_details">**** {{singlePost['short_details']}} ****</h4>
        <div [innerHTML]="singlePost['details']">
        </div>
      </div>
      <section>
        <button class='contactButton' (click)="contactButton(contactVal, reportVal)" #contactB>Contact
          {{singlePost['seller_name']}}</button>
        <button class='reportButton deactivated' (click)="reportButton(contactVal, reportVal)" #reportB>Report
          {{singlePost['seller_name']}}</button>
      </section>

      <form *ngIf="contactVal" [formGroup]="detailsMessageForm" (ngSubmit)="submitMessage($event, singlePost)"
        class="contactForm">
        <input type="text" placeholder="Your Name" value="" formControlName="from_shopper">
        <input type="text" placeholder="Your Email" value="" formControlName="email">
        <input type="text" placeholder="Title" value="" formControlName="title">
        <textarea name="" placeholder="Your Message" id="" cols="30" rows="10" formControlName="message"></textarea>
        <button [disabled]="!detailsMessageForm.valid">Submit</button>
        <div class="loading" *ngIf="submitted==='loading'">
          <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
          <h1>SENDING...</h1>
        </div>
        <div *ngIf="submitted==='submitted'">
          <h1>SUCCESS!</h1>
        </div>
      </form>

      <form *ngIf="reportVal" [formGroup]="detailsReportForm" (ngSubmit)="submitReport($event, singlePost)"
        class="reportForm">
        <input type="text" placeholder="Your Name" value="" formControlName="from_shopper">
        <input type="text" placeholder="Your Email" value="" formControlName="email">
        <input type="text" placeholder="Title" value="" formControlName="title">
        <textarea name="" placeholder="Your Message" id="" cols="30" rows="10" formControlName="message"></textarea>
        <button [disabled]="!detailsReportForm.valid">Submit</button>
        <div class="loading" *ngIf="submitted==='loading'">
          <img src="../../assets/img/ExcessMaterialLoading.png" alt="">
          <h1>SENDING...</h1>
        </div>
        <div *ngIf="submitted==='submitted'">
          <h1>SUCCESS!</h1>
        </div>
      </form>
    </div>
  </section>
</div>

<!-- to_seller = models.CharField(max_length=100, default="----")
from_shopper = models.CharField(max_length=100, default="----")
title = models.CharField(max_length=100)
message = models.TextField()
email = models.CharField(max_length=100, default="----")
created_at = models.DateTimeField(auto_now_add=True)
updated_at = models.DateTimeField(auto_now=True) -->
